import React, { useState, useRef, useEffect } from "react";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Grid,
    Stepper,
    Step,
    StepLabel,
    Checkbox,
    FormControlLabel,
    Select,
    MenuItem,
    InputAdornment,
    FormControl,
    InputLabel,
    OutlinedInput,
    Snackbar,
    Alert,
} from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ApiHelper } from "../../utils/apiHelper";
import { setTempToken, registerIndividual, registerCorporate, setToken } from "../../store/authSlice";
import { useSelector } from "react-redux";
import store from "../../store/store";

const steps = ["Hesap Bilgileri", "Email Onayı", "Kişisel Bilgiler", "Telefon onayı"];

export default function MultiStepForm() {
    const [activeStep, setActiveStep] = useState(0);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [emailCode, setEmailCode] = useState(Array(4).fill(""));
    const [phoneCode, setPhoneCode] = useState(Array(4).fill(""));
    const [isIndividual, setIsIndividual] = useState(true);
    const [country, setCountry] = useState("Turkey"); 
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phone, setPhone] = useState("");
    const [countryCode, setCountryCode] = useState("90"); 
    const [registrationUid, setRegistrationUid] = useState("");

    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const inputsRef = useRef([]);

    const [isValid, setIsValid] = useState(false);

    const dispatch = useDispatch();

    const [title, setTitle] = useState("");
    const [taxOffice, setTaxOffice] = useState("");
    const [taxNumber, setTaxNumber] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [isEntrepreneur, setIsEntrepreneur] = useState(false);
    const [isInvestor, setIsInvestor] = useState(false);

    const handleNext = async () => {
        if (activeStep === 0) {
            try {
                const formData = new URLSearchParams();
                formData.append('email', email);
                formData.append('password', password);
                formData.append('newsletterSubscription', 'false');

                const response = await ApiHelper.post('/register', formData);
                const { data } = response;

                if (data.code === "00000") {
                    setRegistrationUid(data.uid);
                    setActiveStep((prev) => prev + 1);
                } else {
                    throw new Error('Kayıt işlemi başarısız oldu');
                }
            } catch (error) {
                toast.error(error.message || 'Bir hata oluştu');
            }
        } else if (activeStep === 1) {
            try {
                const verificationCode = emailCode.join('');
                const formData = new URLSearchParams();
                formData.append('uid', registrationUid);
                formData.append('verificationCode', verificationCode);

                const response = await ApiHelper.post('/register/verify-email', formData);
                const { data } = response;

                if (data.code === "00000") {
                    if (data.token) {
                        dispatch(setTempToken(data.token));
                    }
                    setActiveStep((prev) => prev + 1);
                    toast.success('Email doğrulama başarılı');
                } else {
                    throw new Error('Email doğrulama başarısız oldu');
                }
            } catch (error) {
                toast.error(error.message || 'Email doğrulama sırasında bir hata oluştu');
            }
        } else if (activeStep === 2) {
            try {
                const commonData = {
                    isEntrepreneur,
                    isInvestor,
                    countryCode,
                    phoneNumber: phone
                };

                if (isIndividual) {
                    const individualData = {
                        ...commonData,
                        name,
                        lastName: surname,
                        birthDate
                    };

                    await dispatch(registerIndividual(individualData)).unwrap();
                } else {
                    const corporateData = {
                        ...commonData,
                        title,
                        taxOffice,
                        taxNumber
                    };

                    await dispatch(registerCorporate(corporateData)).unwrap();
                }

                setActiveStep((prev) => prev + 1);
                toast.success('Kişisel bilgiler başarıyla kaydedildi');
            } catch (error) {
                toast.error(error.message || 'Kişisel bilgiler kaydedilirken bir hata oluştu');
            }
        } else if (activeStep === 3) {
            try {
                const verificationCode = phoneCode.join('');
                const formData = new URLSearchParams();
                formData.append('verificationCode', verificationCode);

                const response = await ApiHelper.post('/register/verify-phone', formData);
                const { data } = response;

                if (data.code === "00000") {
                    const currentTempToken = store.getState().auth.tempToken;
                    dispatch(setToken(currentTempToken));
                    dispatch(setTempToken(null));
                    
                    toast.success('Telefon doğrulama başarılı');
                    window.location.href = '/profil';
                } else {
                    throw new Error('Telefon doğrulama başarısız oldu');
                }
            } catch (error) {
                toast.error(error.message || 'Telefon doğrulama sırasında bir hata oluştu');
            }
        } else {
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleBack = () => setActiveStep((prev) => prev - 1);

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    const handlePaste = (event, step) => {
        const pastedCode = event.clipboardData.getData("Text").slice(0, 6); 
        const codeArray = pastedCode.split("").map((char) => char); 
        if (step === 1) {
            setEmailCode(codeArray);
        } else if (step === 3) {
            setPhoneCode(codeArray);
        }
    };

    const showEmailAlert = () => {
        setAlertMessage("Lütfen email adresinize gönderilen 4 haneli kodu giriniz.");
        setOpenAlert(true);
    };

    const showPhoneAlert = () => {
        setAlertMessage("Lütfen telefon numaranıza gönderilen 4 haneli kodu giriniz.");
        setOpenAlert(true);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            setEmailError("Email adresi gereklidir");
            return false;
        }
        if (!emailRegex.test(email)) {
            setEmailError("Lütfen geçerli bir email adresi giriniz");
            return false;
        }
        setEmailError("");
        return true;
    };

    const validatePassword = (password) => {
        if (!password) {
            setPasswordError("Şifre gereklidir");
            return false;
        }
        if (password.length < 8) {
            setPasswordError("Şifre en az 8 haneli olmalıdır");
            return false;
        }
        if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
            setPasswordError("Şifre en az bir büyük harf, bir küçük harf ve bir sayı içermelidir");
            return false;
        }
        setPasswordError("");
        return true;
    };

    const validateConfirmPassword = (confirmPass) => {
        if (!confirmPass) {
            setConfirmPasswordError("Şifrenizi tekrar giriniz");
            return false;
        }
        if (confirmPass !== password) {
            setConfirmPasswordError("Şifreler eşleşmiyor");
            return false;
        }
        setConfirmPasswordError("");
        return true;
    };

    const accountInfoStep = (
        <Box>
            <Typography variant="h6" gutterBottom>
                Hesap Oluştur
            </Typography>
            <TextField
                label="Email"
                type="email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={() => validateEmail(email)}
                error={!!emailError}
                helperText={emailError}
                sx={{ mb: 2 }}
                required
            />
            <TextField
                label="Şifre"
                type="password"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => validatePassword(password)}
                error={!!passwordError}
                helperText={passwordError}
                sx={{ mb: 2 }}
                required
            />
            <TextField
                label="Şifre Tekrarı"
                type="password"
                variant="outlined"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => validateConfirmPassword(confirmPassword)}
                error={!!confirmPasswordError}
                helperText={confirmPasswordError}
                sx={{ mb: 2 }}
                required
            />
        </Box>
    );

    const emailValidationStep = (
        <Box>
            <Typography variant="h6" gutterBottom>
                Email Doğrulama
            </Typography>
            <Typography variant="body1" gutterBottom>
                Lütfen email adresinize gönderilen 4 haneli kodu giriniz. Eğer email almadıysanız, gelen kutusunu veya spam klasörünüzü kontrol ediniz.
            </Typography>
            <Grid container spacing={1}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <Grid item xs={2} key={index}>
                        <TextField
                            type="text"
                            variant="outlined"
                            fullWidth
                            value={emailCode[index] || ""}
                            onChange={(e) => {
                                const newCode = [...emailCode];
                                newCode[index] = e.target.value.slice(0, 1);
                                setEmailCode(newCode);

                                if (e.target.value && inputsRef.current[index + 1]) {
                                    inputsRef.current[index + 1].focus();
                                }
                            }}
                            inputProps={{ maxLength: 1 }}
                            sx={{ mb: 2 }}
                            required
                            onPaste={(e) => handlePaste(e, 1)} 
                            inputRef={(el) => (inputsRef.current[index] = el)} 
                        />
                    </Grid>
                ))}
            </Grid>
            <Button
                variant="contained"
                onClick={showEmailAlert}
                sx={{ mt: 2 }}
            >
                Email Kodunu Tekrar Gönder
            </Button>
        </Box>
    );

    const personalInfoStep = (
        <Box>
            <Typography variant="h6" gutterBottom>
                Kişisel Bilgiler
            </Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={isIndividual}
                        onChange={() => setIsIndividual(!isIndividual)}
                    />
                }
                label="Bireysel"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={!isIndividual}
                        onChange={() => setIsIndividual(!isIndividual)}
                    />
                }
                label="Kurumsal"
            />

            {isIndividual ? (
                <>
                    <TextField
                        label="Adınız"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />
                    <TextField
                        label="Soyadınız"
                        variant="outlined"
                        fullWidth
                        value={surname}
                        onChange={(e) => setSurname(e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />
                    <TextField
                        label="Doğum Tarihiniz"
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={birthDate}
                        onChange={(e) => setBirthDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2 }}
                        required
                    />
                </>
            ) : (
                <>
                    <TextField
                        label="Ünvanınız"
                        variant="outlined"
                        fullWidth
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />
                    <TextField
                        label="Vergi Dairesi"
                        variant="outlined"
                        fullWidth
                        value={taxOffice}
                        onChange={(e) => setTaxOffice(e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />
                    <TextField
                        label="Vergi Numaranız"
                        variant="outlined"
                        fullWidth
                        value={taxNumber}
                        onChange={(e) => setTaxNumber(e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />
                </>
            )}

            <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Ülke</InputLabel>
                <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    label="Ülke"
                >
                    <MenuItem value="Turkey">Turkey</MenuItem>
                    {/* Add other countries as needed */}
                </Select>
            </FormControl>

            <TextField
                label="Telefon Numaranız"
                variant="outlined"
                fullWidth
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                sx={{ mb: 2 }}
                required
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Select
                                value={countryCode}
                                onChange={(e) => setCountryCode(e.target.value)}
                                sx={{ mr: 1 }}
                            >
                                <MenuItem value="90">90</MenuItem>
                                {/* Add other country codes */}
                            </Select>
                        </InputAdornment>
                    ),
                }}
            />

            <FormControlLabel
                control={
                    <Checkbox
                        checked={isEntrepreneur}
                        onChange={(e) => setIsEntrepreneur(e.target.checked)}
                    />
                }
                label="Girişimci"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={isInvestor}
                        onChange={(e) => setIsInvestor(e.target.checked)}
                    />
                }
                label="Yatırımcı"
            />
        </Box>
    );

    const phoneValidationStep = (
        <Box>
            <Typography variant="h6" gutterBottom>
                Telefon Numaranızı Doğrula
            </Typography>
            <Typography variant="body1" gutterBottom>
                Lütfen telefon numaranıza gönderilen 4 haneli kodu giriniz. Eğer SMS almadıysanız, telefonunuzun mesaj klasörünü kontrol ediniz.
            </Typography>
            <Grid container spacing={1}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <Grid item xs={2} key={index}>
                        <TextField
                            type="text"
                            variant="outlined"
                            fullWidth
                            value={phoneCode[index] || ""}
                            onChange={(e) => {
                                const newCode = [...phoneCode];
                                newCode[index] = e.target.value.slice(0, 1); 
                                setPhoneCode(newCode);

                                if (e.target.value && inputsRef.current[index + 1]) {
                                    inputsRef.current[index + 1].focus();
                                }
                            }}
                            inputProps={{ maxLength: 1 }}
                            sx={{ mb: 2 }}
                            required
                            onPaste={(e) => handlePaste(e, 3)} 
                            inputRef={(el) => (inputsRef.current[index] = el)}
                        />
                    </Grid>
                ))}
            </Grid>
            <Button
                variant="contained"
                onClick={showPhoneAlert}
                sx={{ mt: 2 }}
            >
                SMS Kodunu Tekrar Gönder
            </Button>
        </Box>
    );

    useEffect(() => {
        const checkValidity = () => {
            if (activeStep === 0) {
                const isEmailValid = validateEmail(email);
                const isPasswordValid = validatePassword(password);
                const isConfirmPasswordValid = validateConfirmPassword(confirmPassword);
                setIsValid(isEmailValid && isPasswordValid && isConfirmPasswordValid);
            } else if (activeStep === 1) {
                setIsValid(emailCode.every(code => code.length === 1));
            } else if (activeStep === 2) {
                setIsValid(name && surname && phone && country);
            } else if (activeStep === 3) {
                setIsValid(phoneCode.every(code => code.length === 1));
            }
        };

        checkValidity();
    }, [activeStep, email, password, confirmPassword, emailCode, name, surname, phone, country, phoneCode]);

    return (
        <Container maxWidth="xs" sx={{ mt: 8 }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 3 }}>
                <Stepper activeStep={activeStep} alternativeLabel sx={{ width: "100%" }}>
                    {steps.map((step, index) => (
                        <Step key={index}>
                            <StepLabel>{step}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Box sx={{ mt: 3, width: "100%" }}>
                    {activeStep === 0 && accountInfoStep}
                    {activeStep === 1 && emailValidationStep}
                    {activeStep === 2 && personalInfoStep}
                    {activeStep === 3 && phoneValidationStep}

                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                        <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            variant="outlined"
                        >
                            Geri
                        </Button>
                        <Button
                            onClick={handleNext}
                            variant="contained"
                            disabled={!isValid}
                        >
                            {activeStep === steps.length - 1 ? "Tamamla" : "İleri"}
                        </Button>
                    </Box>
                </Box>

                {/* Snackbar for Alerts */}
                <Snackbar
                    open={openAlert}
                    autoHideDuration={6000}
                    onClose={() => setOpenAlert(false)}
                >
                    <Alert
                        onClose={() => setOpenAlert(false)}
                        severity="info"
                        sx={{ width: "100%", backgroundColor: "#0288d1", color: "#fff" }}
                    >
                        {alertMessage}
                    </Alert>
                </Snackbar>
            </Box>
        </Container>
    );
}
